// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"885fb28d","239":"6f67c464","732":"82488a43"}[chunkId] + ".chunk.js";
};